import reportService from '@/service/reportService'
import lottoService from '@/service/lottoService'

const REPORT_PATH = 'lotto'

const encodePath = value => encodeURIComponent(String(value))

const buildQuery = params => {
  const query = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      query.set(key, String(value))
    }
  })

  const value = query.toString()
  return value ? `?${value}` : ''
}

const roundPath = (huayId, roundId) => (
  `${REPORT_PATH}/${encodePath(huayId)}/${encodePath(roundId)}`
)

export default {
  getBuildStatus(huayId, roundId, params) {
    return reportService.getAuthen(`${roundPath(huayId, roundId)}/status${buildQuery(params)}`)
  },

  requestBuild(huayId, roundId) {
    return lottoService.postAuthen('round-report/build', {
      huayId: String(huayId),
      roundId: String(roundId),
    })
  },

  getByType(huayId, roundId, params) {
    return reportService.getAuthen(`${roundPath(huayId, roundId)}/by-type${buildQuery(params)}`)
  },

  getByNumber(huayId, roundId, params) {
    return reportService.getAuthen(`${roundPath(huayId, roundId)}/by-number${buildQuery(params)}`)
  },

  getByMember(huayId, roundId, params) {
    return reportService.getAuthen(`${roundPath(huayId, roundId)}/by-member${buildQuery(params)}`)
  },

  getItems(huayId, roundId, params) {
    return reportService.getAuthen(`${roundPath(huayId, roundId)}/items${buildQuery(params)}`)
  },

  getBillByRow(txId, params) {
    return reportService.getAuthen(`${REPORT_PATH}/bills/by-row/${encodePath(txId)}${buildQuery(params)}`)
  },
}
